export const GATE_STATUS_LABEL = {
  not_started: 'Not started',
  in_progress: 'In progress',
  ready_for_review: 'Ready for review',
  passed: 'Passed',
  conditional_pass: 'Conditional pass',
  failed: 'Failed',
  deferred: 'Deferred',
};

export const PASSED_GATE_STATUSES = ['passed', 'conditional_pass'];

export const RAG_RANK = { red: 0, amber: 1, green: 2, null: 3, undefined: 3 };

export function scoreColor(pct, total) {
  if (!total) return '#d3d1c7';
  if (pct >= 80) return '#1D9E75';
  if (pct >= 40) return '#EF9F27';
  return '#E24B4A';
}

export function worstRag(values) {
  let worst = null;
  values.forEach((v) => {
    if (v && RAG_RANK[v] < RAG_RANK[worst]) worst = v;
  });
  return worst;
}

export function gateExitStats(criteria) {
  const met = criteria.filter((c) => c.is_met).length;
  const total = criteria.length;
  const pct = total ? Math.round((met / total) * 100) : 0;
  return { met, total, pct };
}

export const DELIVERABLE_ROLE_LABEL = {
  inherited_input: 'Inherited input',
  phase_output: 'Phase output',
  handover_output: 'Handover output',
};
